<template>
    <div v-if="internalValue && internalValue.length <= 0" class="no-results">
        <div>
            <p>Aucun résultat</p>
            <button @click="clear"><span>Supprimer les filtres</span></button>
        </div>
        <figure></figure>
    </div>
</template>

<script>
    export default {
        name: 'Checked',
        props: ['value','label','clear'],
        data: function () {
            return {
                internalValue: null
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/NoResults.vue